// NotFound.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';

const NotFound = () => {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate('/anasayfa');
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', textAlign: 'center' }}>
      <Typography variant="h1" component="div" gutterBottom>
        404
      </Typography>
      <Typography variant="h6" component="div" gutterBottom>
        Sayfa bulunamadı
      </Typography>
      <Button variant="contained" color="primary" onClick={handleBackToHome}>
        Anasayfaya Dön
      </Button>
    </Box>
  );
};

export default NotFound;
